var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DocumentMyBox"},[_c('doc-page',{ref:"docPage",staticClass:"DocumentMy",attrs:{"moduleCode":_vm.moduleCode,"rootFolderId":_vm.rootFolderId,"rootFolderName":_vm.rootFolderName,"folderSource":_vm.folderSource}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }